import { makeStyles, Theme } from '@material-ui/core'

export const useReportStyles = makeStyles((theme: Theme) => ({
  table: {
    marginBottom: theme.spacing(8),
  },
  tableHeaderTitleCell: {
    verticalAlign: 'top',
  },
  tableHeaderUnitCell: {
    paddingTop: theme.spacing(5),
    textAlign: 'center',
  },
  tableHeaderUnitCellWithoutPadding: {
    textAlign: 'center',
  },
  tableValueCell: {
    textAlign: 'center',
  },
  highlightFont: {
    fontWeight: 'bold',
  },
}))
